// Legal page content for /terms and /privacy.
// Each section: { number, title, body: Array<string | { list: string[] }> }
// - Plain string → rendered as a paragraph
// - Object with `list` → rendered as a bulleted list

export const termsContent = {
  title: "Условия использования",
  lastUpdated: "07.09.2026",
  sections: [
    {
      number: 1,
      title: "О платформе",
      body: [
        "EUNOIA (eunoiaspace.eu) — платформа, объединяющая организаторов и участников духовных практик и событий в Европе. Мы предоставляем пространство для публикации, поиска и регистрации на события — мы не являемся организатором самих практик.",
      ],
    },
    {
      number: 2,
      title: "Регистрация",
      body: [
        "Вход на платформу происходит через email, без пароля. Указывая email, вы подтверждаете, что он принадлежит вам.",
      ],
    },
    {
      number: 3,
      title: "Участники",
      body: [
        "Регистрируясь на событие, вы соглашаетесь соблюдать правила, указанные организатором конкретного события (место, время, требования к участию). EUNOIA не несёт ответственности за содержание, безопасность или качество практик, проводимых организаторами — это личная ответственность организатора и осознанный выбор участника.",
      ],
    },
    {
      number: 4,
      title: "Организаторы",
      body: [
        "Создавая событие на платформе, организатор подтверждает, что:",
        {
          list: [
            "предоставленная информация (описание, дата, место, цена) верна;",
            "он несёт полную ответственность за проведение события, безопасность участников и соблюдение применимого законодательства (включая, если требуется, налоговую отчётность по платным событиям);",
            "он обязуется своевременно уведомлять участников об изменениях (перенос, отмена) — платформа отправляет автоматическое уведомление при редактировании опубликованного события.",
          ],
        },
      ],
    },
    {
      number: 5,
      title: "Оплата событий",
      body: [
        "Мы планируем использовать платёжный сервис Stripe для оплаты платных событий; EUNOIA не хранит и не будет хранить данные банковских карт — они обрабатываются непосредственно Stripe согласно его собственным условиям и политике безопасности.",
        "До полного подключения Stripe оплата платных событий и вопросы возврата средств решаются между участником и организатором события напрямую. Этот раздел будет обновлён, как только приём платежей через Stripe заработает на сайте.",
      ],
    },
    {
      number: 6,
      title: "Поведение на платформе",
      body: [
        "Мы создаём тёплое и уважительное пространство. Запрещены: оскорбления, дискриминация, спам, мошенничество, публикация недостоверной информации о событиях.",
      ],
    },
    {
      number: 7,
      title: "Контент",
      body: [
        "Тексты, фото и описания, которые вы публикуете (профиль, события, статьи блога), остаются вашей собственностью, но вы даёте EUNOIA право отображать их на платформе в рамках её обычной работы.",
      ],
    },
    {
      number: 8,
      title: "Ограничение ответственности",
      body: [
        "EUNOIA предоставляет платформу «как есть». Мы не гарантируем непрерывную работу сайта без сбоев и не несём ответственности за действия организаторов или участников за пределами самой платформы.",
      ],
    },
    {
      number: 9,
      title: "Изменения условий",
      body: [
        "Мы можем обновлять эти условия. Дата последнего обновления указана в начале документа. Продолжая использовать платформу после изменений, вы соглашаетесь с обновлённой версией.",
      ],
    },
    {
      number: 10,
      title: "Контакты",
      body: [
        "По всем вопросам: eunoia.community.eu@gmail.com",
      ],
    },
  ],
};

export const privacyContent = {
  title: "Политика конфиденциальности",
  lastUpdated: "07.09.2026",
  sections: [
    {
      number: 1,
      title: "Кто мы",
      body: [
        "EUNOIA (eunoiaspace.eu) — сообщество и платформа для духовных практик и событий в Европе. Контакт по вопросам персональных данных: eunoia.community.eu@gmail.com",
      ],
    },
    {
      number: 2,
      title: "Какие данные мы собираем",
      body: [
        {
          list: [
            "Email — при входе на сайт (обязательно, вход происходит по ссылке без пароля).",
            "Данные профиля — имя, город, текст «о себе», фото профиля, направления практик (по желанию пользователя).",
            "Данные организатора — описание, фото, практики, события, которые он создаёт.",
            "Данные об участии в событиях — какие события пользователь посетил или на какие зарегистрировался.",
            "Переписка — сообщения между участником и организатором внутри платформы.",
            "Техническая информация — стандартные данные браузера/устройства, необходимые для работы сайта.",
          ],
        },
        "Мы не собираем и не храним платёжные данные напрямую. Для платных событий мы планируем использовать платёжный сервис Stripe, у которого своя политика конфиденциальности; до полного подключения оплата платных событий согласуется между участником и организатором напрямую. Этот раздел будет обновлён, как только приём платежей через Stripe заработает на сайте.",
      ],
    },
    {
      number: 3,
      title: "Зачем мы используем эти данные",
      body: [
        {
          list: [
            "Для входа в аккаунт и работы сайта.",
            "Для регистрации на события и связи между участником и организатором.",
            "Для уведомлений — например, если организатор меняет время или место уже забронированного события.",
            "Для отображения профиля организатора другим пользователям.",
          ],
        },
      ],
    },
    {
      number: 4,
      title: "Правовое основание обработки",
      body: [
        "Мы обрабатываем данные на основании:",
        {
          list: [
            "согласия — вы сами вводите email и добровольно заполняете профиль (ст. 6(1)(a) GDPR);",
            "исполнения договора — чтобы предоставить вам сервис, на который вы регистрируетесь (ст. 6(1)(b) GDPR).",
          ],
        },
        "Согласие можно отозвать в любой момент, написав на наш контактный email.",
      ],
    },
    {
      number: 5,
      title: "Сколько мы храним данные",
      body: [
        "Мы храним данные, пока у вас есть аккаунт на EUNOIA, или до тех пор, пока вы не запросите их удаление.",
      ],
    },
    {
      number: 6,
      title: "Кто ещё имеет доступ к данным",
      body: [
        "Мы не продаём и не передаём данные третьим лицам в маркетинговых целях. Доступ к техническому хранению данных может иметь наш технический провайдер (хостинг/база данных сайта) и сервис отправки email — исключительно для работы платформы.",
      ],
    },
    {
      number: 7,
      title: "Ваши права",
      body: [
        "Вы имеете право: запросить, какие данные о вас у нас есть; попросить их исправить; попросить их удалить («право на забвение»); отозвать согласие на обработку в любой момент; подать жалобу в надзорный орган по защите данных (в Эстонии — Andmekaitse Inspektsioon / Data Protection Inspectorate).",
        "Для любого из этих запросов напишите на eunoia.community.eu@gmail.com.",
      ],
    },
    {
      number: 8,
      title: "Cookies",
      body: [
        "Мы не используем cookies для отслеживания и аналитики. Сайт может использовать только технически необходимые файлы (например, для хранения сессии входа) — без согласия на них сайт не сможет работать.",
      ],
    },
    {
      number: 9,
      title: "Изменения политики",
      body: [
        "Мы можем обновлять эту политику. Дата последнего обновления указана в начале документа.",
      ],
    },
  ],
};
